<template>
	<div>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<v-card-text v-else-if="isBlocked !== null">
			<div class="note__search-wrapper">
				<h2 class="note__search-wrapper__title">Choose a Person</h2>
				<div
					:class="[
						'note__search-wrapper__input',
						{ 'note__search-wrapper__active': filters.search },
					]"
				>
					<div class="d-flex w-100 pr-3 align-center">
						<input
							type="text"
							class="px-3 py-2"
							placeholder="Search"
							v-model="filters.search"
							@input="filterSearch"
							style="outline: none"
						/>
						<Icon type="search" :size="24" color="#002855" />
					</div>
				</div>
			</div>

			<div>
				<v-skeleton-loader
					v-if="isLoading"
					type="list-item-avatar, list-item-avatar, list-item-avatar"
				></v-skeleton-loader>
				<div v-else>
					<UserAddNoteItem
						v-for="user in users"
						:key="user.user_id"
						:user="user"
						:selectedUser="selectedUser"
						v-on:selectUser="selectUser"
					/>
				</div>
			</div>

			<div
				class="d-flex my-9 justify-center notes-page__pagination"
				v-if="!isLoading && users.length > 0"
			>
				<Pagination
					:page="filters.page"
					:pageCount="+this.pageCountAttendees"
					v-on:pageChange="onPageChange"
				/>
			</div>
		</v-card-text>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/images/search.svg'
import UserAddNoteItem from '@/components/Profile/UserAddNoteItem.vue'
import Pagination from '@/components/Pagination.vue'
import ButtonBack from '../../components/ButtonBack.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'

const DEBOUNCE_TIMEOUT = 500

export default {
	components: {
		UserAddNoteItem,
		Pagination,
		ButtonBack,
		PageBlocked,
	},
	mixins: [Block],
	data() {
		return {
			searchIcon,
			filters: {
				page: 1,
				search: '',
			},
			selectedUser: null,
			pageBlockedName: 'profile',
		}
	},
	computed: {
		...mapGetters('event', ['isLoading', 'pageCountAttendees', 'attendees']),
		...mapGetters('auth', ['profile']),
		...mapGetters('settings', ['appCore']),

		users() {
			return this.attendees
		},
	},
	methods: {
		...mapActions('event', ['getAttendeesEvent', 'clearAttendeesEvent']),

		filterSearch(e) {
			clearTimeout(this.timer)

			this.filters.page = 1

			this.timer = setTimeout(() => {
				this.getAttendeesEvent(`?page=${1}&search=${e.target.value}`)
			}, DEBOUNCE_TIMEOUT)
		},

		onPageChange(page) {
			if (page !== this.filters.page) {
				this.filters.page = page
				this.getAttendeesEvent(`?page=${page}&search=${this.filters.search}`)
			}
		},
		selectUser(user) {
			this.selectedUser = user
		},
	},
	created() {
		!this.isBlocked && this.getAttendeesEvent()
	},
	beforeDestroy() {
		this.clearAttendeesEvent()
	},
}
</script>

<style lang="scss">
.note {
	&__search-wrapper {
		font-family: 'Inter', sans-serif;
		display: flex;
		gap: 16px;
		align-items: center;
		justify-content: space-between;
		padding: 8px;
		border: 1px solid #e2e2e2;
		border-radius: 8px;
		background-color: #ffffff;
		margin-bottom: 16px;
		&__title {
			font-weight: 700;
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0;
			color: var(--accent-color);
		}
		&__input {
			border: 1px solid #e2e2e2;
			border-radius: 8px;
			background-color: #ffffff;
			input {
				font-family: 'Inter', sans-serif;
				font-weight: 400;
				font-size: 14px;
				line-height: 100%;
				letter-spacing: 0;
				color: #4a4a4a;
			}
		}
		&__active {
			border: 1.5px solid #0055a3;
			box-shadow: 0 0 0 2px #0055a333;
		}
	}
}
</style>
